<template>
  <div class="row search-ads-campaigns-stats">
    <div class="columns large-7 small-12">
      <SearchAdsCampaignsStatsChart
        v-loading="isLoading"
        :impression-counts="campaignOverview.stats.impressionCounts"
        :conversion-rates="campaignOverview.stats.conversionRates"
        :dates="campaignOverview.stats.dates"
        :total-impression-count="campaignOverview.totalImpressionCount"
        :average-conversion-rate="campaignOverview.conversionRate"
      />
    </div>
    <div
      class="columns large-5 small-12 search-ads-campaigns-stats__box-wrapper"
    >
      <div class="row search-ads-campaigns-stats__box">
        <SearchAdsCampaignsStatsBudgetBox
          v-loading="isLoading"
          :average-budget="campaignOverview.averageDailyInstallCost"
          :total-budget="campaignOverview.totalSpentBudget"
          :spent-budget="campaignOverview.todayConsumedBudget"
        />
      </div>
      <div class="row  search-ads-campaigns-stats__box">
        <SearchAdsCampaignsStatsInstallBox
          v-loading="isLoading"
          :average-install="campaignOverview.averageDailyInstallCount"
          :total-install="campaignOverview.totalInstallCount"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SearchAdsCampaigns } from '@/api/api';
import SearchAdsCampaignsStatsBudgetBox from './SearchAdsCampaignsStatsBudgetBox';
import SearchAdsCampaignsStatsInstallBox from './SearchAdsCampaignsStatsInstallBox';
import SearchAdsCampaignsStatsChart from './SearchAdsCampaignsStatsChart';

export default {
  name: 'SearchAdsCampaignsStats',
  components: {
    SearchAdsCampaignsStatsBudgetBox,
    SearchAdsCampaignsStatsInstallBox,
    SearchAdsCampaignsStatsChart,
  },
  props: {
    range: {
      type: String,
      required: true,
    },
    updateController: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,

      campaignOverview: {
        averageDailyInstallCost: 0,
        averageDailyInstallCount: 0,
        totalImpressionCount: 0,
        conversionRate: 0,
        stats: { conversionRates: [], impressionCounts: [], dates: [] },
        totalInstallCount: 0,
        totalSpentBudget: 0,
        todayConsumedBudget: 0,
      },
    };
  },
  watch: {
    range(newRange, oldRange) {
      if (oldRange !== newRange) {
        this.getCampaignOverview();
      }
    },
  },
  created() {
    this.getCampaignOverview();

    this.updateController.onUpdate(this.getCampaignOverview);
  },
  beforeDestroy() {
    this.updateController.removeOnUpdate(this.getCampaignOverview);
  },
  methods: {
    getCampaignOverview() {
      this.isLoading = true;
      return SearchAdsCampaigns.getOverview(this.range)
        .then(campaignOverview => {
          this.campaignOverview = campaignOverview;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.search-ads-campaigns-stats {
  margin: $global-margin 0 $global-margin * 2.2 0;

  &__box-wrapper {
    @include breakpoint(medium down) {
      margin-top: $global-margin;
    }
  }

  &__box:first-child {
    margin-bottom: $global-margin * 1.5;
  }
}
</style>
